import { isArray } from "lodash"
import showSnackbar from "./showSnackbar"
import { muiTheme } from "./mui"
import { MessageTypeEnum } from "common/enums"
import dayjs from "dayjs"

export function getValueWithMask(
  value: string,
  mask: string,
): [string, string] {
  const regexFilter = mask.match(/[a-z]/i) ? /[^a-z\d]/gi : /\D/gi
  const maskedValue = formatAlphaNumeric(value.replace(regexFilter, ""), mask)
  const rawValue = maskedValue.replace(/[^a-z\d]/gi, "")

  return [rawValue, maskedValue]
}

export function copyToClipboard(
  text: string,
  onSuccess?: VoidFunction,
  onError?: VoidFunction,
) {
  const isiOS = navigator.userAgent.match(/ipad|iphone/i);

  if (isiOS) {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);

    const range = document.createRange();
    const selection = window.getSelection();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);

    el.setSelectionRange(0, 999999);

    try {
      document.execCommand('copy');
      onSuccess && onSuccess();
    } catch (error) {
      console.warn('Error copying text:', error);
      onError && onError();
    }

    document.body.removeChild(el);
  } else {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        onSuccess && onSuccess();
      })
      .catch((error) => {
        console.warn('Error copying text:', error);
        onError && onError();
      });
  }
}

export function formatAlphaNumeric(
  value: string | number,
  format: string | string[],
): string {
  if (!value) {
    return ""
  }

  const formats = isArray(format) ? format : [format]
  let masked = ""

  for (let i = 0; i < formats.length; i++) {
    masked = ""
    let aux = String(value).replace(/[^a-z\d]/gi, "")

    for (let j = 0; j < formats[i].length; j++) {
      if (!aux.length) {
        break
      }

      if (formats[i][j] === "A" || formats[i][j] === "9") {
        masked += aux.slice(0, 1)
        aux = aux.slice(1)
      } else {
        masked += formats[i][j]

        if (formats[i][j] === aux[0]) {
          aux = aux.slice(1)
        }
      }
    }

    if (masked.length === formats[i].length) {
      return masked
    }
  }

  return masked || String(value)
}

export function redirectToAlyviaSSO() {
  showSnackbar('Redirecionando para o Alyvia SSO', 'warning')
  setTimeout(() => {
    window.location.href = `${process.env.REACT_APP_ALYVIA_SSO_URL || 'https://sso.alyvia.app'}/login`
  }, 3000)
}

export function checkSenderNameNotUnknown(name: string | null) {
  if (name === null) {
    return null
  }

  if (name.toLowerCase() === 'unknown' || name.toLowerCase() === 'desconhecido') {
    return null
  }

  return name
}

export const isJwtValid = (token: string | null) => {
  if (!token) return false

  try {
    const [, payloadBase64] = token.split(".")
    const payload = JSON.parse(atob(payloadBase64))
    const now = Math.floor(Date.now() / 1000)

    return payload.exp && payload.exp > now
  } catch (error) {
    return false
  }
}

export const defaultColorPallete = muiTheme.palette

export function formatBytes(bytes, decimalPlaces = 2) {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const formattedSize = (bytes / Math.pow(k, i)).toFixed(decimalPlaces)
  return `${formattedSize}${sizes[i]}`
}

export const mapBlobTypeToMessageTypeEnum = (blob: Blob): MessageTypeEnum => {
  if (blob.type.startsWith('image/')) {
    return MessageTypeEnum.image
  }
  if (blob.type.startsWith('video/')) {
    return MessageTypeEnum.video
  }
  if (blob.type.startsWith('audio/')) {
    return MessageTypeEnum.audio
  }

  return MessageTypeEnum.document
}

 export const handleDownloadFile = (fileUrl: string, fileType: 'image' | 'doc' | 'video' | 'video') => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `AlyviaChat ${fileType} ${dayjs().format('DD_MM_YYYY HH:mm:ss')}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
